import { z } from 'zod';

export const SUserResponse = z.object({
  id: z.number(),
  username: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  whatsapp: z.string(),
  gmail: z.string().nullable(),
  email: z.string().nullable(),
});
export type TUserResponse = z.infer<typeof SUserResponse>;
